<script setup lang="ts">
/***
 * template to customergroup
 */
const _props = defineProps<DataTableCellProps>();
import { navigationItems } from '@/router/navigation';

import type { DataTableCellProps } from './templateTypes';
const groupsIcon = `${navigationItems?.find((a) => a.name === 'customergroups')?.icon ?? 'mdi mdi-factory'} sey-icon mr-1`;
</script>

<template>
  <span :class="groupsIcon"> </span>
  <RouterLink
    v-tooltip="{ value: cell.value.description, showDelay: 300 }"
    class="a-inline"
    :to="`/customergroups/${cell.value.id}`"
    >{{ cell.value.name }}</RouterLink
  >
</template>
